export const attentionDemands = [
  'Read more',
  'Watch more',
  'Learn more',
  'Book more time',
]

export const rewards = [
  'Time saved',
  'Workflow clarity',
  'Clinical insight',
  'Less friction',
  'A reason to go deeper',
]

export const recognitionThoughts = [
  'This will be quick.',
  'This will be useful.',
  'Solventum usually delivers.',
]

export const proofPoints = [
  {
    product: 'Digital Bonding',
    invested: '30 seconds invested',
    returned: '18 minutes',
    detail: 'saved in the bonding workflow',
  },
  {
    product: 'Precision Grip Attachments',
    invested: '30 seconds invested',
    returned: '12 minutes',
    detail: 'saved per bonding procedure, on average',
  },
]

export const trustSteps = [
  { order: 'First time', text: 'HCPs see a countdown.' },
  { order: 'Second time', text: 'They recognize the format.' },
  { order: 'Over time', text: 'Solventum doesn’t waste my time.' },
]

export const trustOutcomes = [
  'Higher engagement',
  'Stronger credibility',
  'More willingness to click',
  'More trust in future communication',
]
